import { render, staticRenderFns } from "./Treemap.vue?vue&type=template&id=1ff022ed&"
import script from "./Treemap.vue?vue&type=script&lang=js&"
export * from "./Treemap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports